// extracted by mini-css-extract-plugin
export default {"root":"TabSwitch_root__5SYDS","tabButton":"TabSwitch_tabButton__eFm-P","activeTab":"TabSwitch_activeTab__OxV8B"};